<template>
  <div class="cart">
      <slot></slot>
  </div>
</template>